<template>
    <div
        class="absolute flex space-x-1"
        :class="[
            pricing.headerLayout === PRICING_HEADER_LAYOUTS.standard
                ? '-top-6 right-0'
                : '-bottom-6 right-6',
        ]"
        :style="{
            color: pricing.titleColor,
        }"
    >
        <span
            :class="[finalLayout !== 'basic' ? 'opacity-50 hover:opacity-100' : 'opacity-100']"
            class="cursor-pointer"
            @click="$emit('changeLayout', 'basic')"
        >
            <LayoutHorizontal3Icon class="h-4 w-4" />
        </span>
        <span
            :class="[finalLayout !== 'grid' ? 'opacity-50 hover:opacity-100' : 'opacity-100']"
            class="cursor-pointer"
            @click="$emit('changeLayout', 'grid')"
        >
            <LayoutHorizontal4Icon class="h-4 w-4" />
        </span>
        <span
            :class="[finalLayout !== 'list' ? 'opacity-50 hover:opacity-100' : 'opacity-100']"
            class="cursor-pointer"
            @click="$emit('changeLayout', 'list')"
        >
            <LayoutVertical2Icon class="h-4 w-4" />
        </span>
        <span
            :class="[finalLayout !== 'links' ? 'opacity-50 hover:opacity-100' : 'opacity-100']"
            class="cursor-pointer"
            @click="$emit('changeLayout', 'links')"
        >
            <LayoutVertical4Icon class="h-4 w-4" />
        </span>
        <span
            :class="[finalLayout !== 'shared' ? 'opacity-50 hover:opacity-100' : 'opacity-100']"
            class="cursor-pointer"
            @click="$emit('changeLayout', 'shared')"
        >
            <LayoutSquare2Icon class="h-4 w-4" />
        </span>
    </div>
</template>

<script>
import {
    LayoutHorizontal3Icon,
    LayoutHorizontal4Icon,
    LayoutVertical2Icon,
    LayoutVertical4Icon,
    LayoutSquare2Icon,
} from "@easy/ui/icons";
import { PRICING_HEADER_LAYOUTS } from "@/apps/pricing/services/pricing.service";

export default {
    name: "LayoutToggle",
    components: {
        LayoutHorizontal3Icon,
        LayoutHorizontal4Icon,
        LayoutVertical2Icon,
        LayoutVertical4Icon,
        LayoutSquare2Icon,
    },
    emits: ["changeLayout"],
    props: {
        pricing: Object,
        finalLayout: String,
    },
    data() {
        return {
            PRICING_HEADER_LAYOUTS,
        };
    },
};
</script>
